import axios from 'axios';
import AppConfig from 'config';

const jwtToken = localStorage.getItem('access_token');

const SingleTranscriptController = {
  async getAudio(transcriptId) {
    try {
      const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO + `transcripts_page/transcripts/` + transcriptId, {
        headers: {
          'Authorization': `Bearer ${jwtToken}`
        },
        responseType: 'blob'
      });

      const audioUrl = URL.createObjectURL(response.data);
      return audioUrl;
    } catch (error) {
      console.error("Error fetching profiles:", error);
      throw error;
    }
  },
  async listTranscriptsSearchAudio(idTranscript) {
    try {
      const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO + `transcripts_page/search_by_id/` + idTranscript, {
        headers: {
          Authorization: `Bearer ${jwtToken}`
        }
      });
      return response.data.result[0];
    } catch (error) {
      console.error("Error fetching profiles:", error);
      throw error;
    }
  },
};

export default SingleTranscriptController;